/*
This file is located in the main branch
Last time the file was updated (UTC): [14.03.2024 6:25:34]
Permissions to update outside the main branch: [false]
*/

export const ENVIRONMENT_DOM = 'dom';
export const ENVIRONMENT_COL = 'col';
export const ENVIRONMENT_MEX = 'mex';
export const ENVIRONMENT_IND = 'ind';

export type EnvironmentFullNameType =
    | 'India'
    | 'Colombia'
    | 'Dominicana'
    | 'Peru'
    | 'Mexico'
    | 'Uzbekistan'
    | 'Pakistan'
    | 'Russia'
    | 'Default';

export const ENVIRONMENT_FULLNAMES: { [id: string]: EnvironmentFullNameType } = {
    ind: 'India',
    col: 'Colombia',
    dom: 'Dominicana',
    per: 'Peru',
    mex: 'Mexico',
    'mex-card': 'Mexico',
    uzb: 'Uzbekistan',
    pak: 'Pakistan',
    rus: 'Russia',
    '': 'Default',
};

export const MODE_DEV = 'dev';
export const MODE_TEST = 'test';
export const MODE_PROD = 'prod';

export default abstract class Environment {
    static EnvironmentIsIn = (environmentsList: string[]) => {
        const env = Environment.GetEnvironment();
        return env ? environmentsList.indexOf(env) > -1 : false;
    };

    static GetMode = () => process.env.REACT_APP_MODE || '';

    static GetEnvironment = () => process.env.REACT_APP_ENVIRONMENT || '';

    static GetEnvironmentFullName = (): EnvironmentFullNameType =>
        ENVIRONMENT_FULLNAMES[process.env.REACT_APP_ENVIRONMENT || ''];

    static GetSirnalRUrl = () => process.env.REACT_APP_SIGNAL_R_URL || '';

    static GetPublicUrl = () => process.env.PUBLIC_URL || '';

    static GetWidgetSrc = () => process.env.REACT_APP_WIDGET_SRC || '';

    static GetWidgetPath = () => process.env.REACT_APP_WIDGET_PATH || '';

    static GetWidgetUri = () => process.env.REACT_APP_CRM_WIDGET_URI || '';
}

if (Environment.GetMode() === MODE_DEV) {
    console.log(
        `%cAPP STARTED!
    environment: ${Environment.GetEnvironment()}
    signalR url: ${Environment.GetSirnalRUrl()}
    public url: ${Environment.GetPublicUrl()}`,
        'background: #222; color: #bada55; font-size: 20px'
    );
}
